import { render } from "./Area.vue?vue&type=template&id=3a06c274&scoped=true"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"

import "./Area.vue?vue&type=style&index=0&id=3a06c274&scoped=true&lang=css"
import "./Area.vue?vue&type=style&index=1&id=3a06c274&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a06c274"]])

export default __exports__